module.exports = __webpack_public_path__ + "static/media/icon_data-mark-unread.b6c3a210.svg";